/**
 * DateFieldType — sama data. Storage: PG DATE. Format: YYYY-MM-DD.
 */

import type { FieldInputProps, FieldTypeDefinition } from '../FieldRegistry';

function DateInput({ field, value, onChange, error, disabled, autoFocus }: FieldInputProps) {
  const stringValue = typeof value === 'string' ? value : '';
  return (
    <input
      type="date"
      value={stringValue}
      onChange={(e) => onChange(e.target.value || null)}
      disabled={disabled}
      autoFocus={autoFocus}
      aria-invalid={!!error}
      data-testid={`field-${field.slug}-input`}
      className="w-full rounded-md border border-border-primary bg-bg-primary px-3 py-2 text-sm text-text-primary focus:border-accent-500 focus:outline-none focus:ring-1 focus:ring-accent-500 disabled:opacity-50"
    />
  );
}

export const DateFieldType: FieldTypeDefinition = {
  type: 'date',
  renderInput: (props) => <DateInput {...props} />,
  renderCell: (_field, value) => {
    if (typeof value !== 'string' || !value) return '';
    // YYYY-MM-DD → DD.MM.YYYY (ludzkie PL)
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
    return m ? `${m[3]}.${m[2]}.${m[1]}` : value;
  },
  defaultValue: null,
};
